export class Singleton {
  private static _instance: unknown;

  protected static Instance<T>(Constructor: { new (): T }): T {
    if (!this._instance) {
      this._instance = new Constructor();
    }

    return this._instance as T;
  }
}
